import { useRef, useEffect, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

const EmployeeSign = ({ open, onClose, onComplete }) => {

  // Main State
  const sigRef = useRef(null);
  const [hasDrawn, setHasDrawn] = useState(false);

  // Pad-Size Control
  const wrapperRef = useRef(null);
  const [size, setSize] = useState({ width: 300, height: 300 });
  useEffect(() => {
    if (!open) return;

    const resize = () => {
      if (!wrapperRef.current) return;
      const w = wrapperRef.current.offsetWidth;
      setSize({ width: w, height: w });
    };

    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, [open]);

  // Capture & Clean-up
  const handleClear = () => {
    sigRef.current?.clear();
    setHasDrawn(false);
  };
  const handleReset = () => {
    onClose();
    handleClear();
  };
  const handleDone = async () => {
    if (!sigRef.current || sigRef.current.isEmpty()) return;

    const canvas = sigRef.current.getCanvas();

    const squareCanvas = document.createElement("canvas");
    const size = Math.max(canvas.width, canvas.height);
    squareCanvas.width = size;
    squareCanvas.height = size;

    const ctx = squareCanvas.getContext("2d");
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, size, size);

    const offsetX = (size - canvas.width) / 2;
    const offsetY = (size - canvas.height) / 2;
    ctx.drawImage(canvas, offsetX, offsetY);

    const dataUrl = squareCanvas.toDataURL("image/png");
    const blob = await fetch(dataUrl).then(res => res.blob());
    const file = new File([blob], `signature-${Date.now()}.png`, { type: "image/png" });

    onComplete(file);
    handleReset();
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-3">
      <div className="bg-white rounded-xl w-full max-w-md p-3">
        <h3 className="text-lg font-semibold mb-2">Draw Signature</h3>

        <div ref={wrapperRef} className="border border-dashed border-gray-400 rounded-lg overflow-hidden">
          <SignatureCanvas
            ref={sigRef}
            onBegin={() => setHasDrawn(true)}
            canvasProps={{
              width: size.width,
              height: size.height,
              className: "bg-white"
            }}
          />
        </div>

        <div className="flex justify-between mt-4">
          <button
            type="button"
            onClick={handleClear}
            className="px-3 py-1.5 text-sm bg-gray-200 rounded-lg"
          >
            Clear
          </button>

          <div className="flex gap-2">
            <button
              type="button"
              onClick={handleReset}
              className="px-3 py-1.5 text-sm bg-gray-200 rounded-lg"
            >
              Cancel
            </button>
            <button
              type="button"
              disabled={!hasDrawn}
              onClick={handleDone}
              className={`px-3 py-1.5 text-sm rounded-lg transition
                ${hasDrawn
                  ? "bg-blue-600 text-white hover:bg-blue-700"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
                }
            `}
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeSign;